module.exports = __webpack_public_path__ + "static/media/liquidity-promo.cf5c891f.webp";